import { Controller } from "@hotwired/stimulus"

// A <details> used as a menu or popover. Closes on Escape (returning focus to
// its summary), on a click outside it, or from a button inside it wired to
// details#close.
export default class extends Controller {
  close() {
    this.element.open = false
  }

  closeOnEscape(event) {
    if (event.key !== "Escape" || !this.element.open) return

    this.close()
    this.element.querySelector("summary")?.focus()
  }

  closeOnClickOutside(event) {
    if (this.element.open && !this.element.contains(event.target)) this.close()
  }
}
